import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner, SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
/** Person header: eyebrow, name, "{title} · {employer}" and the page actions. */ export function ContactHeader({ dossier, onLogTouchpoint, extraActions }) {
    const employerHref = dossier.employer ? registryHref(dossier.employer) : null;
    const employerLabel = dossier.employer?.name || dossier.employerText;
    const employer = employerLabel ? employerHref ? /*#__PURE__*/ _jsx(SpecraLink, {
        href: employerHref,
        renderLink: renderRouterLink,
        children: employerLabel
    }) : employerLabel : null;
    const description = dossier.currentTitle || employer ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            dossier.currentTitle,
            dossier.currentTitle && employer ? ' · ' : null,
            employer
        ]
    }) : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            dossier.requestedIdWasMerged && /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
                tone: "info",
                variant: "framed",
                children: [
                    "This person was merged into ",
                    dossier.name,
                    "."
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                titleSize: "home",
                eyebrow: `Person · ${dossier.hasPlatformAccount ? 'platform account' : 'no platform account'}`,
                title: dossier.name,
                description: description,
                actions: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        onLogTouchpoint ? /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "secondary",
                            onClick: onLogTouchpoint,
                            "data-testid": Testids.registryPerson.logTouchpoint,
                            children: "Log touchpoint"
                        }) : // A touchpoint is filed on a pursuit or program; keep the action visible (mockup)
                        // and say why it's unavailable instead of hiding it.
                        /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "secondary",
                            disabled: true,
                            title: "Add this person to a pursuit or program to log touchpoints",
                            "data-testid": Testids.registryPerson.logTouchpointDisabled,
                            children: "Log touchpoint"
                        }),
                        extraActions,
                        /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "ghost",
                            asChild: true,
                            children: renderRouterLink({
                                href: `/registries?tab=contacts&record=${encodeURIComponent(dossier.id)}${dossier.isActive ? '' : '&inactive=1'}`,
                                children: 'Edit'
                            })
                        })
                    ]
                })
            })
        ]
    });
}
